import gql from 'graphql-tag'

export default gql`
	mutation resetRangeLoyaltyCards($ids: RangeIds!, $fields: LoyaltyCardFields, $transactionFields: RangeLoyaltyCardFields) {
		cashAssist {
			resetRangeLoyaltyCards(ids: $ids, fields: $fields, transactionFields: $transactionFields)
		}
	}
`
